import { PROPAGANDA } from "../modules/cart/type";
import { StateManager } from "../redux/stateManager";
import Store from "../redux/store";

// 宣传媒体平台图标
export function propagandaIcon(item: string) {
    let imgWay = '' as any;
    switch (item) {
        case PROPAGANDA.FACEBOOK:
            imgWay = require('../assets/propaganda/facebook.png');
            break;
        case PROPAGANDA.GOOGLE:
            imgWay = require('../assets/propaganda/google.png');
            break;
        case PROPAGANDA.INSTAGRAM:
            imgWay = require('../assets/propaganda/Instagram.png');
            break;
        case PROPAGANDA.TIKTOK:
            imgWay = require('../assets/propaganda/tiktok.png');
            break;
        case PROPAGANDA.TRIPADVISOR:
            imgWay = require('../assets/propaganda/TripAdvisor.png');
            break;
        case PROPAGANDA.TWITTER:
            imgWay = require('../assets/propaganda/Twitter.png');
            break;
        case PROPAGANDA.WHATSAPP:
            imgWay = require('../assets/propaganda/WhatsApp.png');
            break;
        default:
            break;
    }
    return imgWay;
}
/**
 * 过敏源和调味品的图片
 * @param item  图片名称
 *
 */
export function allergen(item: string) {
    let imgWay = '' as any;
    switch (item) {
        case 'fish':
            imgWay = require('../assets/allergy/fish.png');
            break;
        case 'lupin':
            imgWay = require('../assets/allergy/lupin.png');
            break;
        case 'mustard':
            imgWay = require('../assets/allergy/mustard.png');
            break;
        case 'soya':
            imgWay = require('../assets/allergy/soya.png');
            break;
        case 'sulphites':
            imgWay = require('../assets/allergy/sulphites.png');
            break;
        case 'sesame':
            imgWay = require('../assets/allergy/sesame.png');
            break;
        case 'peanuts':
            imgWay = require('../assets/allergy/peanuts.png');
            break;
        case 'eggs':
            imgWay = require('../assets/allergy/eggs.png');
            break;
        case 'milk':
            imgWay = require('../assets/allergy/milk.png');
            break;
        case 'crustaceans':
            imgWay = require('../assets/allergy/crustaceans.png');
            break;
        case 'celery':
            imgWay = require('../assets/allergy/celery.png');
            break;
        case 'tree_nuts':
            imgWay = require('../assets/allergy/tree_nuts.png');
            break;
        case 'gluten':
            imgWay = require('../assets/allergy/gluten.png');
            break;
        case 'molluscs':
            imgWay = require('../assets/allergy/molluscs.png');
            break;
        case 'frozen_origin':
            imgWay = require('../assets/condiment/frozen_origin.png');
            break;
        case 'medium_spicy':
            imgWay = require('../assets/condiment/medium_spicy.png');
            break;
        case 'vegetarian':
            imgWay = require('../assets/condiment/vegetarian.png');
            break;
        case 'gluten_free':
            imgWay = require('../assets/condiment/gluten_free.png');
            break;
        case 'raw':
            imgWay = require('../assets/condiment/raw.png');
            break;
        case 'cooked':
            imgWay = require('../assets/condiment/cooked.png');
            break;
        case 'additives':
            imgWay = require('../assets/condiment/additives.png');
            break;
        case 'colourants':
            imgWay = require('../assets/condiment/colourants.png');
            break;
        case 'mild_spicy':
            imgWay = require('../assets/condiment/mild_spicy.png');
            break;
        case 'very_spicy':
            imgWay = require('../assets/condiment/very_spicy.png');
            break;
        case 'blast_freezing':
            imgWay = require('../assets/condiment/blast_freezing.png');
            break;
        case 'vegan':
            imgWay = require('../assets/condiment/vegan.png');
            break;
        default:
            break;
    }
    return imgWay;
}

/**
 * 菜品标识非圆型图标
 * @returns 
 */
export function getDishIdentsDark(item: string) {
    let imgWay = '' as any;
    switch (item) {
        case 'fish':
            imgWay = require('../assets/allergy/fish.png');
            break;
        case 'lupin':
            imgWay = require('../assets/allergy/lupin.png');
            break;
        case 'mustard':
            imgWay = require('../assets/allergy/mustard.png');
            break;
        case 'soya':
            imgWay = require('../assets/allergy/soya.png');
            break;
        case 'sulphites':
            imgWay = require('../assets/allergy/sulphites.png');
            break;
        case 'sesame':
            imgWay = require('../assets/allergy/sesame.png');
            break;
        case 'peanuts':
            imgWay = require('../assets/allergy/peanuts.png');
            break;
        case 'eggs':
            imgWay = require('../assets/allergy/eggs.png');
            break;
        case 'milk':
            imgWay = require('../assets/allergy/milk.png');
            break;
        case 'crustaceans':
            imgWay = require('../assets/allergy/crustaceans.png');
            break;
        case 'celery':
            imgWay = require('../assets/allergy/celery.png');
            break;
        case 'tree_nuts':
            imgWay = require('../assets/allergy/tree_nuts.png');
            break;
        case 'gluten':
            imgWay = require('../assets/allergy/gluten.png');
            break;
        case 'molluscs':
            imgWay = require('../assets/allergy/molluscs.png');
            break;
        case 'frozen_origin':
            imgWay = require('../assets/dark-condiment/frozen_origin.png');
            break;
        case 'medium_spicy':
            imgWay = require('../assets/dark-condiment/medium_spicy.png');
            break;
        case 'vegetarian':
            imgWay = require('../assets/dark-condiment/vegetarian.png');
            break;
        case 'gluten_free':
            imgWay = require('../assets/dark-condiment/gluten_free.png');
            break;
        case 'raw':
            imgWay = require('../assets/dark-condiment/raw.png');
            break;
        case 'cooked':
            imgWay = require('../assets/dark-condiment/cooked.png');
            break;
        case 'additives':
            imgWay = require('../assets/dark-condiment/additives.png');
            break;
        case 'colourants':
            imgWay = require('../assets/dark-condiment/colourants.png');
            break;
        case 'mild_spicy':
            imgWay = require('../assets/dark-condiment/mild_spicy.png');
            break;
        case 'very_spicy':
            imgWay = require('../assets/dark-condiment/very_spicy.png');
            break;
        case 'blast_freezing':
            imgWay = require('../assets/dark-condiment/blast_freezing.png');
            break;
        case 'vegan':
            imgWay = require('../assets/dark-condiment/vegan.png');
            break;
        default:
            break;
    }
    return imgWay;
}

/**
 * 获取websocket的url
 */
export function getWebsocketUrl() {
    const GlobalConfig = StateManager.getFromCache('GlobalConfig') || {};
    const strArr = (GlobalConfig.WEBSOCKET_SERVER_URL).split('://');
    // websocket的配置文件直接有正规的url地址，可以直接获取
    if (Array.isArray(strArr) && strArr.length > 1) {
        return strArr[1];
    }
    //  else {
    //     // 没有正确的地址尝试用服务器地址替代。3002是shark默认的websocket端口
    //     const strArr = (Store.getState().serverUrl).split(':');
    //     const serverUrl = strArr.length > 1 ? strArr[1].split('//') : [];
    //     return `${serverUrl.length > 1 ? serverUrl[1] : 'localhost'}:3002`;
    // }
}

/**
 * 主要用于解决IOS长脸机型 + Safari浏览器
 * 因为现在 iPhone 在 iPhone X 之后的机型都需要适配，所以可以对 X 以后的机型统一处理
 * 在 H5 上可以简单处理。
 */
export const isIphonex = () => {
    if (typeof window !== 'undefined' && window) {
        return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
    }
    return false;
};

export const PHONE_TYPE = navigator.userAgent;


/**
 * 预加载nginx图片
 * @param url 路径
 * @param replaceFrom 需要截取的字符 
 * @param replaceTo   取代的字符 
 * @param serverUrl   使用菜品默认图片
 */
export const preLoadNginxImage = (url: string, replaceFrom: string, replaceTo: string, defaultImage?: boolean) => {
    return new Promise((resolve: (value: string) => void, reject) => {
        const img = new Image();
        const imgRandomNumberParam = StateManager.getFromCache('imgRandomNumberParam');
        const originUrl = url += `?${imgRandomNumberParam}`
        img.src = originUrl;
        img.onerror = () => {
            // 去掉nginx路径
            const newUrl = originUrl.replace(replaceFrom, replaceTo);
            const img2 = new Image();
            img2.src = newUrl;
            img2.onerror = async () => {
                // 使用默认菜品图片
                if (defaultImage) {
                    let imgUrl = `${Store.getState().serverUrl}/menu_pic/menu_default.jpg`;
                    const lastUrl = await preLoadNginxImage(imgUrl, '/menu_pic', '');
                    return resolve(lastUrl)
                }
                resolve('')
            };
            img2.onload = () => { resolve(newUrl) };
        };
        img.onload = () => { resolve(originUrl) };
    });
}

